import PropTypes from "prop-types";
import PubSub from "pubsub-js";
import React, { PureComponent } from "react";
import { connect } from "react-redux";

import { withScreenContext } from "../../components/screen/ScreenContext";
import PubSubTopics from "../../constants/pubSubTopics";
import screenModes from "../../constants/screenModes";
import { appStateSelectors } from "../../modules/appState";
import batchOperations from "../../modules/batchOperations";
import { PropTypeShapes } from "../../types";
import { mergeDispatchToProps } from "../../utils/codeSplit";
import preprocessorQuery from "../../utils/preprocessorQuery";
import { WorkspaceContext } from "./WorkspaceContext";

class Workspace extends PureComponent {
  constructor(props, context) {
    super(props, context);

    this._workspaceContextState = {
      registerWorkViewCreateItemCallback: this.registerWorkViewCreateItemCallback.bind(this),
      unregisterWorkViewCreateItemCallback: this.unregisterWorkViewCreateItemCallback.bind(this)
    };
    this._createItemHandlersForView = {};
    this.onCreateItemReceived = this.onCreateItemReceived.bind(this);
  }

  componentDidMount() {
    this._pubSubCreateItemToken = PubSub.subscribe(PubSubTopics.createItem, this.onCreateItemReceived);
  }

  componentWillUnmount() {
    PubSub.unsubscribe(this._pubSubCreateItemToken);
  }

  registerWorkViewCreateItemCallback = (viewId, callback) => {
    this._createItemHandlersForView[viewId] = callback;
  };

  unregisterWorkViewCreateItemCallback = viewId => {
    delete this._createItemHandlersForView[viewId];
  };

  onCreateItemReceived(msg, data) {
    const isMobile = preprocessorQuery.isMobile();
    const isMobilePortrait =
      isMobile && this.props.screenContext && this.props.screenContext.screenMode === screenModes.MobilePortrait;

    // First see if there is a registered callback for additional messages
    const viewId = isMobilePortrait ? "primaryView" : this.props.activeView;
    const handler = Object.prototype.hasOwnProperty.call(this._createItemHandlersForView, viewId)
      ? this._createItemHandlersForView[viewId]
      : null;

    // Otherwise, if not in the side list, see if the active view wants to handle the event.
    // It will return true if it succeeds, and false if it fails
    let handled = handler ? handler(data.typeId) : false;
    // If handled, we are done.
    if (handled) {
      return;
    }
    // Otherwise, we should create it ourselves
    this.props.onCreateItem(data.typeId);
  }

  render() {
    return (
      <WorkspaceContext.Provider value={this._workspaceContextState}>{this.props.children}</WorkspaceContext.Provider>
    );
  }
}

Workspace.propTypes = {
  activeView: PropTypes.string.isRequired,
  onCreateItem: PropTypes.func.isRequired,
  children: PropTypeShapes.elementOrArray.isRequired,
  // From withScreenContext
  screenContext: PropTypes.object
};

const mapStateToProps = state => {
  return {
    activeView: appStateSelectors.getActiveViewId(state.present)
  };
};

const readonlyActions = {};

const editingActions = {
  onCreateItem: batchOperations.createAndSelectItem
};

const mapDispatchToProps = dispatch => mergeDispatchToProps(readonlyActions, editingActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withScreenContext(Workspace));
